export default {
  data() {
    return {
      // 当前渲染的可见范围（起始和结束索引）
      range: {
        start: 0,
        end: 0
      },
      keeps: 40, // 视窗可见区域能容纳的最大条目数
      buffer: 20, // 滚动缓冲区域，提前加载不可见区域的内容，改善滚动体验
      perHeight: this.rowHeight || 50, // 行高度
      savedOffset: 0 // 保存的滚动位置（可能用于恢复滚动状态）
    };
  },
  methods: {
    // 计算列表前部的空白填充高度（用于模拟长列表）
    getPadFront() {
      return this.perHeight * this.range.start;
    },
    // 计算列表后部的空白填充高度
    getPadBehind() {
      const end = this.range.end;
      const lastIndex = this.getLastIndex();
      return (lastIndex - end) * this.perHeight; // 结束索引后的总高度
    },
    // 根据起始索引计算结束索引
    getEndByStart(start) {
      const lastIndex = this.getLastIndex();
      const end =
        start + this.keeps - 1 >= lastIndex // 防止越界
          ? lastIndex
          : start + this.keeps - 1; // 保持可见项数量不超过 keeps

      return end;
    },
    // 核心方法：根据滚动位置计算渲染范围
    caculate(isFront, offset) {
      // 重新计算需要渲染的列表区间
      const overs = this.getScrollOvers(offset);
      console.log(overs);
      let start = overs;
      // 处理向上滚动（加载更早的内容）
      if (isFront) {
        if (overs > this.range.start) {
          return;
        }
        start = Math.max(overs - this.buffer, 0);
      } else if (overs < this.range.start + this.buffer) {
        // 处理向下滚动（加载更多内容）
        return;
      }
      this.checkRange(start, this.getEndByStart(start));
    },
    // 重置渲染范围（通常在数据源变化时调用）
    resetRange(data, start = 0) {
      if (!data || data.length === 0) {
        this.range = {
          start: 0,
          end: 0
        };
        return;
      }

      if (start >= data.length) {
        start = 0;
      }
      this.checkRange(start, this.getEndByStart(start));
    },
    // 验证并修正渲染范围
    checkRange(start, end) {
      const keeps = this.keeps;
      const total = this.virtualList.length;
      // 当总数小于等于视窗容量时，显示全部
      if (total <= keeps) {
        start = 0;
        end = this.getLastIndex();
      } else if (end - start < keeps - 1) {
        // 当实际渲染数量不足时，调整起始位置
        start = end - keeps + 1;
      }
      // 仅在范围变化时更新
      if (this.range.start !== start || this.range.end !== end) {
        this.range = {
          start,
          end
        };
      }
    },
    // 获取虚拟滚动数组最后一个索引
    getLastIndex() {
      return Math.max(this.virtualList.length - 1, 0);
    },
    // 根据滚动偏移量计算当前滚动到的条目索引
    getScrollOvers(offset) {
      if (offset <= 0) return 0;
      return Math.floor(offset / this.perHeight);
    }
  }
};
